module.exports = __webpack_public_path__ + "static/img/8areaA_02.7be2b1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/8areaA_02.png
// module id = 917
// module chunks = 1